import ApplicationComponent from "legacy/ApplicationComponent"
import Paginator from "legacy/Paginator"
import { boatDisplayText, inchesToFeet } from "legacy/helpers.es6"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class UnassignedReservationView extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      reservations: [],
      page: 1,
      numberOfPages: null,
      totalReservationCount: null,
      isLoading: true,
    }
    this.fetchReservations = this.fetchReservations.bind(this)
    this.goToPage = this.goToPage.bind(this)
  }

  componentDidMount() {
    this.fetchReservations()
  }

  fetchReservations() {
    this.setState({ isLoading: true })
    $.get(
      `${
        this.props.unassignedReservationsEndpoint
      }?night=${this.props.night.format("YYYY-MM-DD")}&page=${this.state.page}`,
      (data) => {
        this.setState({
          isLoading: false,
          reservations: data.unassigned_reservations,
          numberOfPages: data.num_pages,
          totalReservationCount: data.unassigned_reservations_count,
        })
      }
    )
  }

  goToPage(page) {
    this.setState({ page }, () => this.fetchReservations())
  }

  renderEachReservation() {
    return _.map(this.state.reservations, (reservation) => {
      return (
        <div
          className="w-full rounded bg-gray-100 p-3"
          key={reservation.encoded_id}
        >
          <div className="row-flex no-gutters">
            <div className="col-xs-6 mb-3">
              <div className="font-bold">Customer</div>
              {reservation.contact.name}
            </div>
            <div className="col-xs-6 mb-3">
              <div className="font-bold">Vessel</div>
              {boatDisplayText(
                reservation.contact_boat.name,
                inchesToFeet(reservation.contact_boat.length_overall),
                reservation.contact_boat.boat_type
              )}
            </div>
            <div className="col-xs-6 mb-3">
              <div className="font-bold">Arrival</div>
              {moment(reservation.check_in_date, "YYYY-MM-DD").format(
                "dddd MM/DD/YYYY"
              )}
            </div>
            <div className="col-xs-6 mb-3">
              <div className="font-bold">Departure</div>
              {moment(reservation.check_out_date, "YYYY-MM-DD").format(
                "dddd MM/DD/YYYY"
              )}
            </div>
          </div>
          <button
            type="button"
            className="btn btn-secondary w-full"
            onClick={() =>
              this.props.loadReservationForSidebar(reservation.encoded_id)
            }
          >
            Assign
          </button>
        </div>
      )
    })
  }

  renderLoadedView() {
    return (
      <div className="flex h-screen w-full flex-col justify-start">
        <div
          className="space-y-2 overflow-y-scroll"
          style={{ paddingBottom: 170 }}
        >
          <h4 className="mt-0 font-semibold">
            <i className="fa-kit fa-assignment mr-2" />
            Assign Reservations
          </h4>
          <p>{`${
            this.state.totalReservationCount
          } unassigned reservations on ${this.props.night.format(
            "MM/DD/YYYY"
          )}`}</p>
          <div
            className="grid gap-2"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            }}
          >
            {this.renderEachReservation()}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 mt-auto border-t bg-white py-4 xl:sticky xl:-mb-4">
          <Paginator
            page={this.state.page}
            numberOfPages={this.state.numberOfPages}
            totalItemsCount={this.state.totalReservationCount}
            goToPage={this.goToPage}
          />
        </div>
      </div>
    )
  }

  renderLoadingView() {
    return (
      <div className="flex h-screen flex-col justify-start">
        <h4 className="mb-4 mt-0 font-semibold">
          <i className="fa-kit fa-assignment mr-2" />
          Assign Reservations
        </h4>
        <p>Loading unassigned reservations...</p>
      </div>
    )
  }

  render() {
    return this.state.isLoading
      ? this.renderLoadingView()
      : this.renderLoadedView()
  }
}

UnassignedReservationView.propTypes = {
  loadReservationForSidebar: PropTypes.func.isRequired,
  night: PropTypes.object.isRequired,
  unassignedReservationsEndpoint: PropTypes.string.isRequired,
}

export default UnassignedReservationView
